import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  open,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-178">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} data-id="element-179">
          <div className="absolute inset-0 bg-midnight-deep/90 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-180" />

          <motion.div role="dialog" aria-modal="true" aria-labelledby="modal-title" initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[85vh] bg-midnight border-2 border-cyan-signal/30 shadow-[0_0_60px_rgba(61,169,252,0.15)] flex flex-col" data-id="element-181">
            <div className="flex items-center justify-between border-b border-cyan-signal/20 px-6 md:px-8 py-5 flex-shrink-0" data-id="element-182">
              <h3 id="modal-title" className="font-display text-xl md:text-2xl text-bone uppercase tracking-wide" data-id="element-183">
                {title}
              </h3>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 flex items-center justify-center text-steel hover:text-cyan-signal hover:bg-cyan-signal/10 transition-colors" data-id="element-184">
                <X className="w-5 h-5" data-id="element-185" />
              </button>
            </div>

            <div className="overflow-y-auto px-6 md:px-8 py-6 text-steel leading-relaxed space-y-5 text-[15px]" data-id="element-186">
              {children}
            </div>

            <div className="border-t border-cyan-signal/20 px-6 md:px-8 py-4 flex justify-end flex-shrink-0" data-id="element-187">
              <button onClick={onClose} className="bg-cyan-signal text-midnight-deep px-6 py-2 font-bold uppercase tracking-widest text-sm hover:bg-cyan-signal/90 transition-colors" data-id="element-188">
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}